import { createContext } from "react";
import {
  WarehouseArticleSettingsDeleteContextValue,
  WarehouseArticleSettingsHandlerContextValue,
} from "./types";

/* ===========================================================================
 * CONTEXT: WarehouseArticleSettingsHandlerContext
 * ===========================================================================
 */

/**
 * @constant WarehouseArticleSettingsHandlerContext
 *
 * Provides CRUD logic and state management for warehouse article settings,
 * including:
 * - loading and error handling
 * - create and update flows
 * - configuration comparison state
 * - domain-specific save functionality
 *
 * This context represents the core business logic layer for
 * WarehouseArticleSettings forms.
 * Must be consumed via `useWarehouseArticleSettingsHandlerContext()`
 * and wrapped inside a `WarehouseArticleSettingsProvider`.
 */
export const WarehouseArticleSettingsHandlerContext = createContext<
  WarehouseArticleSettingsHandlerContextValue | undefined
>(undefined);

/* ===========================================================================
 * CONTEXT: WarehouseArticleSettingsDeleteContext
 * ===========================================================================
 */

/**
 * @constant WarehouseArticleSettingsDeleteContext
 *
 * Provides deletion logic for warehouse article settings:
 * - loading state management
 * - delete API handling
 * - success and error callback execution
 *
 * Designed for components that handle single or batch delete operations.
 * Must be consumed via `useWarehouseArticleSettingsDeleteContext()`
 * and wrapped inside a `WarehouseArticleSettingsProvider`.
 */
export const WarehouseArticleSettingsDeleteContext = createContext<
  WarehouseArticleSettingsDeleteContextValue | undefined
>(undefined);
